(() => {
  const initialise = () => {
    document.querySelectorAll('[data-product-id="15447167008936"]').forEach(root => {
      if (root.dataset.tnbColourPhotoReady) return;
      const template = root.parentElement.querySelector('[data-tnb-colour-photo-map]');
      const holder = root.parentElement.querySelector('[data-tnb-colour-photo]');
      const gallery = root.querySelector('[data-product-images]');
      if (!template || !holder || !gallery) return;
      root.dataset.tnbColourPhotoReady = 'true';
      const photos = JSON.parse(template.textContent);
      gallery.parentElement.append(holder);
      const image = holder.querySelector('img');
      const link = holder.querySelector('a');
      const display = title => {
        const source = photos[title];
        holder.hidden = !source;
        root.toggleAttribute('data-tnb-colour-photo-active', Boolean(source));
        if (source) {
          image.src = source + (source.includes('?') ? '&' : '?') + 'width=1200';
          image.alt = title;
          link.href = source;
        } else {
          requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        }
      };
      root.addEventListener('change', event => {
        if (event.target.matches('[data-variant-input]')) display(event.target.value);
      });
      root.addEventListener('variantChange', event => {
        if (event.detail && event.detail.variant) display(event.detail.variant.title);
      });
      const selected = root.querySelector('[data-variant-input]:checked');
      if (selected) display(selected.value);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();